import {
  PLUM_100,
  BLUE_100,
  YELLOW_100,
  RED_100,
  GREEN_100,
  CLEMENTINE_100,
  RASPBERRY_100,
  INK_100,
  PLUM_500,
  BLUE_500,
  YELLOW_500,
  RED_500,
  GREEN_500,
  CLEMENTINE_500,
  RASPBERRY_500,
  INK_500,
  PLUM_700,
  BLUE_700,
  YELLOW_700,
  RED_700,
  GREEN_700,
  CLEMENTINE_700,
  RASPBERRY_700,
  INK_700,
} from 'cio/utils/colors';

// [FIXME] Orange is clementine and pink is raspberry. We should use the consistent names everywhere.

export default [
  {
    label: 'A',
    color: 'purple',
    hex: PLUM_100,
    hex_medium: PLUM_500,
    hex_dark: PLUM_700,
    hex_name: 'plum-100',
    hex_medium_name: 'plum-500',
    hex_dark_name: 'plum-700',
  },
  {
    label: 'B',
    color: 'blue',
    hex: BLUE_100,
    hex_medium: BLUE_500,
    hex_dark: BLUE_700,
    hex_name: 'blue-100',
    hex_medium_name: 'blue-500',
    hex_dark_name: 'blue-700',
  },
  {
    label: 'C',
    color: 'yellow',
    hex: YELLOW_100,
    hex_medium: YELLOW_500,
    hex_dark: YELLOW_700,
    hex_name: 'yellow-100',
    hex_medium_name: 'yellow-500',
    hex_dark_name: 'yellow-700',
  },
  {
    label: 'D',
    color: 'red',
    hex: RED_100,
    hex_medium: RED_500,
    hex_dark: RED_700,
    hex_name: 'red-100',
    hex_medium_name: 'red-500',
    hex_dark_name: 'red-700',
  },
  {
    label: 'E',
    color: 'green',
    hex: GREEN_100,
    hex_medium: GREEN_500,
    hex_dark: GREEN_700,
    hex_name: 'green-100',
    hex_medium_name: 'green-500',
    hex_dark_name: 'green-700',
  },
  {
    label: 'F',
    color: 'orange',
    hex: CLEMENTINE_100,
    hex_medium: CLEMENTINE_500,
    hex_dark: CLEMENTINE_700,
    hex_name: 'clementine-100',
    hex_medium_name: 'clementine-500',
    hex_dark_name: 'clementine-700',
  },
  {
    label: 'G',
    color: 'pink',
    hex: RASPBERRY_100,
    hex_medium: RASPBERRY_500,
    hex_dark: RASPBERRY_700,
    hex_name: 'raspberry-100',
    hex_medium_name: 'raspberry-500',
    hex_dark_name: 'raspberry-700',
  },
  {
    label: 'H',
    color: 'ink',
    hex: INK_100,
    hex_medium: INK_500,
    hex_dark: INK_700,
    hex_name: 'ink-100',
    hex_medium_name: 'ink-500',
    hex_dark_name: 'ink-700',
  },
];
